import { render, staticRenderFns } from "./UserForget.vue?vue&type=template&id=d0da545e&scoped=true&"
import script from "./UserForget.vue?vue&type=script&lang=js&"
export * from "./UserForget.vue?vue&type=script&lang=js&"
import style0 from "./UserForget.vue?vue&type=style&index=0&id=d0da545e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0da545e",
  null
  
)

export default component.exports